namespace advisorop.components.common {
    
    class ChartLinePerformanceController{
        performanceDetails: Array<any> = undefined;
        chartCategories: Array<domains.IZoomlineChartCategories> = new Array<domains.IZoomlineChartCategories>();
        chartDataSet: Array<domains.IZoomlineChartDataSet> = new Array<domains.IZoomlineChartDataSet>();
        chartSettings: domains.IZoomlineChartSettings = {
            subcaption: "Click & drag on the plot area to zoom. Select legend items to toggle plotting.",
            yaxisname: "Performance",
            xaxisname: "Date",
            forceaxislimits: "1",
            pixelsperpoint: "0",
            pixelsperlabel: "30",
            compactdatamode: "1",
            dataseparator: "|",
            theme: "fint",
            numberScaleValue: ".01",
            numberScaleUnit: "%",
            labelDisplay: "rotate",
            slantLabel: "1",
            useEllipsesWhenOverflow: "0",
            yAxisMaxValue: "0",
            yAxisMinValue: "0"
        };

        chart: domains.IZoomlineChart = {
            chart: this.chartSettings,
            categories: this.chartCategories,
            dataset: this.chartDataSet
        };

        constructor(private advisorService: services.AdvisorService) {                        
        }

        initialized(chart) {
        }

        $onChanges(evt) {
            for (var key in evt) {
                if (key === "performanceDetails" && this.performanceDetails) {
                    //console.log("PERFORMANCE DATA UPDATED:", this.performanceDetails);
                    this.updateChart();
                }
            }
        }

        initializeChart(): void {
            this.chart = {
                chart: this.chartSettings,
                categories: this.chartCategories,
                dataset: this.chartDataSet
            };
        }

        updateChart(): void {

            this.initializeChart();

            var maxOverallVal: number = 0;
            var minOverallVal: number = 0;

            // set up x axis
            this.chart.categories.length = 0;
            var groupPerformanceDates = this.performanceDetails[0].timeSeries.map(function (item) {
                var date = new Date(item['performanceDate']);
                var ret = (((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear());
                return ret;
            });
            var xaxis = groupPerformanceDates.join("|");
            this.chart.categories.push({ category: xaxis });

            // set up lines

            // Account Group in Total
            this.chart.dataset.length = 0;
            var ydata = this.performanceDetails[0].timeSeries.map(function (item) {
                maxOverallVal = Math.max(item['ptpValue'], maxOverallVal);
                minOverallVal = Math.min(item['ptpValue'], minOverallVal);
                return item['ptpValue'];
            });
            var y1 = ydata.join("|");
            this.chart.dataset.push({ seriesname: "Total Performance", data: y1, initiallyHidden: 0 });

            // Individual Accounts:
            this.performanceDetails[0].details.forEach((element) => {
                if (element.performance.ptpValue != 0 && element.performance.timeSeries != null) {
                    var accountPerformanceDates = element.performance.timeSeries.map(function (item) {
                        var date = new Date(item['performanceDate']);
                        var ret = (((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear());
                        return ret;
                    });
                    var accountPerformance = groupPerformanceDates.map(function (item) {
                        var found = accountPerformanceDates.indexOf(item);
                        if (found >= 0) {
                            var val = element.performance.timeSeries[found].ptpValue;
                            maxOverallVal = Math.max(val, maxOverallVal);
                            minOverallVal = Math.min(val, minOverallVal);
                            return val;
                        }
                        else
                            return null;
                    });
                    var seriesData = accountPerformance.join("|");
                    var seriesName = element.performance.accountName
                        + " - " + element.performance.productDescription
                        + " (" + element.performance.accountNumber + ")";
                    // Initially hide lines that are not the Total Performance lin, the user can activate any of these lines manually.
                    this.chart.dataset.push({ seriesname: seriesName, data: seriesData, initiallyHidden: 1 });
                }
            });

            maxOverallVal = maxOverallVal + .01;
            minOverallVal = minOverallVal - .01;
            this.chart.chart.yAxisMaxValue = maxOverallVal.toFixed(2);
            this.chart.chart.yAxisMinValue = minOverallVal.toFixed(2);
        }

        $onInit(): void {

        }

        $routerOnActivate(next, previous) {
        }
    }



    class ChartLinePerformance implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        
        constructor() {
            this.bindings = {
                performanceDetails: "<"
            };
            this.controller = ChartLinePerformanceController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/common/chart-line-performance.html';            
        }
    }
    angular.module(Constants.APP).component("chartLinePerformance", new ChartLinePerformance());
    
}